'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _dec3, _class, _class2, _temp;
// import { Link } from 'react-router';
// import config from '../../config';
// remove this one
// import {isLoaded, load as loadWidgets} from 'redux/modules/widgets';

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactI18next = require('react-i18next');

var _contentPage = require('redux/modules/contentPage');

var contentPageActions = _interopRequireWildcard(_contentPage);

var _reactBootstrap = require('react-bootstrap');

var _reactHtmlParser = require('react-html-parser');

var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);

var _reduxAsyncConnect = require('redux-async-connect');

var _reactRedux = require('react-redux');

var _reactKatex = require('react-katex');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isLoaded = contentPageActions.isLoaded,
    loadContentsNoLesson = contentPageActions.loadContentsNoLesson;
var ContentPageNoLesson = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  deferred: true,
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState,
        id = _ref.params.id,
        location = _ref.location;

    // if (!isLoaded(getState())) {

    // }
    return dispatch(loadContentsNoLesson(id));
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    directions: state.contentPage.data
  };
}, (0, _extends3.default)({}, contentPageActions)), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(ContentPageNoLesson, _Component);

  function ContentPageNoLesson() {
    (0, _classCallCheck3.default)(this, ContentPageNoLesson);
    return (0, _possibleConstructorReturn3.default)(this, (ContentPageNoLesson.__proto__ || (0, _getPrototypeOf2.default)(ContentPageNoLesson)).apply(this, arguments));
  }

  (0, _createClass3.default)(ContentPageNoLesson, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var styles = require('./Home.scss');
      var _props = this.props,
          t = _props.t,
          directions = _props.directions;

      var previousPage = Number(this.props.params.id) > 1 ? Number(this.props.params.id) - 1 : Number(this.props.params.id);

      //nextPage needs to be checked by total page (by contents per page)
      //Load contentCount => page = contentCount/10
      //## shoud write an api to check for future uses of mobile???
      //  API:: /contents/pagesCount(with number contents/page)
      var nextPage = Number(this.props.params.id) + 1;

      var pagination = _react2.default.createElement(
        _reactBootstrap.Pager,
        null,
        Number(this.props.params.id) > 1 && _react2.default.createElement(
          _reactBootstrap.PageItem,
          { previous: true, href: '/page/' + previousPage, onSelect: function onSelect() {
              _this2.props.history.push('/page/' + previousPage);
            } },
          '\u2190 ',
          t('content.previous_page')
        ),
        _react2.default.createElement(
          _reactBootstrap.PageItem,
          { next: true, href: '/page/' + nextPage, onSelect: function onSelect() {
              console.log(_this2.props.params);
              _this2.props.history.push('/page/' + nextPage);
            } },
          t('content.next_page'),
          ' \u2192'
        )
      );

      return _react2.default.createElement(
        'div',
        { className: styles.home },
        _react2.default.createElement(_reactHelmet2.default, { title: 'Home' }),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          pagination,
          _react2.default.createElement(
            'div',
            null,
            directions !== undefined && directions.map(function (item, i) {
              // console.log(item);
              if (item.active === 1) {
                return _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement('b', { dangerouslySetInnerHTML: { __html: item.name } }),
                  _react2.default.createElement(
                    'div',
                    null,
                    item && (0, _reactHtmlParser2.default)(item.data, { decodeEntities: true, transform: function transform(node, index) {
                        if (node.type === 'tag' && node.name === 'span' && node.attribs.class === "math-q") {
                          // node.name = 'InlineMath';
                          // console.log("what");
                          // console.log(node);
                          // console.log(index);
                          return _react2.default.createElement(_reactKatex.InlineMath, { math: node.children[0].data.slice(2, -2) });
                        }

                        //Find image tag: <span><img src=\"content/lessons/28/obitan_1.PNG\" /></span>
                        if (node.type === 'tag' && node.name === 'img') {
                          // console.log(node);
                          if (node.attribs.src.startsWith('content/lessons/')) {
                            // console.log("matchedddd.....");
                            var newSrc = 'http://hochochoc.com/www/' + node.attribs.src; //should be dynamic.... by using env...

                            return _react2.default.createElement('img', { src: newSrc });
                          }
                        }
                      } })
                  ),
                  _react2.default.createElement(
                    _reactBootstrap.Button,
                    { bsStyle: 'link', onClick: function onClick() {
                        return _this2.props.history.push('/content/' + item.id);
                      } },
                    t('content.see_more')
                  ),
                  _react2.default.createElement(
                    _reactBootstrap.Button,
                    { bsStyle: 'link', onClick: function onClick() {
                        return _this2.props.history.push('/content/' + item.id + '/edit');
                      } },
                    t('content.edit')
                  )
                );
              }
            })
          ),
          pagination
        )
      );
    }
  }]);
  return ContentPageNoLesson;
}(_react.Component), _class2.propTypes = {
  t: _react.PropTypes.func,
  directions: _react.PropTypes.array
}, _temp)) || _class) || _class) || _class);
exports.default = ContentPageNoLesson;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Content/ContentPageNoLesson.js
// module id = 1519
// module chunks = 0